import { createContext, useContext } from "react";

import type { SystemOverviewFilters } from "./types";

export const SystemOverviewFiltersContext = createContext<
  SystemOverviewFilters | undefined
>(undefined);

export const useSystemOverviewFiltersContext = (): SystemOverviewFilters => {
  const context = useContext(SystemOverviewFiltersContext);

  if (!context) {
    throw new Error(
      "useSystemOverviewFiltersContext must be used within a SystemOverviewFiltersProvider",
    );
  }

  return context;
};
